<template>
  <div>
    <Dialog
      :header="header"
      :visible.sync="displayConfirmation"
      :modal="modal"
      :dismissableMask="dismissableMask"
      :position="position"
      :ariaCloseLabel="ariaCloseLabel"
      :closable="closable"
      :contentStyle="contentStyle"
      :rtl="rtl"
    >
      <slot name="content"></slot>

      <template #footer>
        <slot name="buttons" :clicked="closeConfirmation"></slot>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "primevue/dialog";

export default {
  components: {
    Dialog,
  },
  props: {
    message: {
      type: String,
    },
    icon: {
      type: String,
      default: null,
    },
    header: {
      type: String,
      default: "",
    },
    dismissableMask: {
      type: Boolean,
      default: true,
    },
    modal: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: "center",
    },
    ariaCloseLabel: {
      type: String,
      default: "close",
    },
    closable: {
      type: Boolean,
      default: true,
    },
    contentStyle: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },
    rtl: {
      type: Boolean,
      default: false,
    },
    displayConfirmation: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    closeConfirmation() {
      this.$emit("confirm");
    },
  },
};
</script>
